import { useTranslation } from 'react-i18next'
import { CurecallToggle, ECurecallSize } from '@honestica/curecall-ui'
import { useTimezonePreference } from 'src/providers/timezone-preference.provider'

type Props = {
  isProjectTimezone: boolean
  onToggle: () => void
}

const TimezoneInputSelector = ({ isProjectTimezone, onToggle }: Props) => {
  const { t } = useTranslation()
  const { hasTimezoneMismatch, projectTimezone, browserTimezone } = useTimezonePreference()

  if (!hasTimezoneMismatch) return null

  const displayedTimezone = isProjectTimezone ? projectTimezone : browserTimezone

  return (
    <div className="c-flex c-items-center c-gap-2 c-mt-1 c-text-xs c-text-gray-500">
      <CurecallToggle isEnabled={isProjectTimezone} onChange={onToggle} size={ECurecallSize.SMALL} />
      <span>
        {isProjectTimezone
          ? t('components.timezone-input-selector.project-timezone')
          : t('components.timezone-input-selector.your-timezone')}
        {displayedTimezone && <span className="c-ml-1 c-opacity-70">({displayedTimezone})</span>}
      </span>
    </div>
  )
}

export default TimezoneInputSelector
